import { Button, Popconfirm, Space, theme } from 'antd';
import { FC } from 'react';
import { BoxArrowUpRight, ExclamationCircle, Trash } from 'react-bootstrap-icons';

import { DescriptionBlock } from '../../../../../common/components';
import { CommonDrawerTitle } from '../../../../../common/layouts';
import { Hosting } from '../../../entities';

interface Props {
  hosting: Hosting;
  disableButtons: boolean;
  loadingButtons: boolean;
  handleDeleteHosting: () => void;
}

export const HostingsOverviewView: FC<Props> = ({
  hosting,
  disableButtons,
  loadingButtons,
  handleDeleteHosting
}) => {
  const { token } = theme.useToken();

  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <Popconfirm
              disabled={ disableButtons }
              title="Видалити цей хостинг?"
              onConfirm={ handleDeleteHosting }
              okType="danger"
              okText="Так"
              icon={ <ExclamationCircle color={ token.colorError }/> }
              placement="bottomRight"
            >
              <Button
                loading={ loadingButtons }
                disabled={ disableButtons }
                danger
                icon={ <Trash/> }
              >
                Видалити
              </Button>
            </Popconfirm>
          </Space>
        }
      />

      <DescriptionBlock items={ [['Назва', hosting.name]] }/>
      <DescriptionBlock
        items={ [
          [
            'Посилання',
            <a key={ hosting.link } href={ hosting.link } target="_blank" rel="noreferrer">
              { hosting.link }&nbsp;
              <BoxArrowUpRight/>
            </a>
          ]
        ] }
      />
    </>
  );
};
